import { NpsSurveyWindow } from '@rhwb/types';

/** "Season 16" -> "16". Null when there is no recognisable current season. */
export function seasonNumberFrom(current: string | null | undefined): string | null {
  const match = (current || '').match(/Season\s+(\d+)/i);
  return match ? match[1] : null;
}

/**
 * Whether to ask the API if this person can take the survey. Runners and
 * hybrids always. Admins and lords resolve to their oversight role even when
 * they also run, so on the survey page the API decides from the season roster;
 * the dashboard never prompts them, so it does not ask.
 */
export function asksSurveyEligibility(role: string | undefined, onSurveyPage: boolean): boolean {
  if (role === 'runner' || role === 'athlete' || role === 'hybrid') return true;
  return onSurveyPage && (role === 'admin' || role === 'lord');
}

/**
 * Whether the dashboard should send this runner to the survey. Runners only:
 * hybrids are coaches who also run, and the survey stays a link for them.
 */
export function shouldPromptForSurvey({
  role,
  open,
  alreadySubmitted,
}: {
  role: string | undefined;
  open: boolean;
  alreadySubmitted: boolean;
}): boolean {
  return (role === 'runner' || role === 'athlete') && open && !alreadySubmitted;
}

// Dates arrive as YYYY-MM-DD calendar days; format them as such, in UTC, so a
// browser west of Greenwich does not show the day before.
function formatDay(day: string): string {
  return new Date(`${day}T00:00:00Z`).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

/** What the survey page says when the survey is not open. */
export function closedMessage(window: NpsSurveyWindow | null | undefined): string {
  if (window?.state === 'scheduled' && window.opens_on) {
    return `The survey opens on ${formatDay(window.opens_on)}.`;
  }
  if (window?.state === 'closed' && window.closes_on) {
    return `The survey closed on ${formatDay(window.closes_on)}. Thank you to everyone who shared feedback.`;
  }
  return 'The survey is not open right now.';
}
